import React, { type JSX } from 'react';

/**
 * Display a message in case the user has no items in the shopping cart.
 */
export const EmptyShoppingCart = (props: { pageExtSearchResults: string }): JSX.Element => {
  return (
    <div className="container text-center">
      <i className="fa fa-shopping-cart fa-5x mt-4 color d-flex align-items-center justify-content-center"
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          fontSize: '43px',
          height: '100px',
          width: '100px',
          color: '#ccc',
          background: '#f1f1f1',
          borderRadius: '50%',
        }}
        aria-hidden="true"/>
      <h1>Winkelwagen</h1>
      <p>
        Je hebt geen training geselecteerd.
        Kies eerst <a href={props.pageExtSearchResults}>een training</a>.
      </p>
    </div>
  );
};
